import type {OrgRepositoryPickerSelection} from '@github-ui/item-picker/OrgRepositoryPicker'

/**
 * Org login for the paved-path route (/orgs/:org/issues/:number), or undefined to use the default
 * repository navigation.
 *
 * `orgPavedPathEnabled` is the only flag checked here: the org picker only lists account_issues
 * enrolled orgs, so an `org` selection already implies enrollment (the other backend gate).
 */
export function resolveAccountIssueOrgLogin({
  createMore,
  orgRepoSelection,
  orgPavedPathEnabled,
}: {
  createMore: boolean
  orgRepoSelection: OrgRepositoryPickerSelection | undefined
  orgPavedPathEnabled: boolean
}): string | undefined {
  if (createMore || !orgPavedPathEnabled || orgRepoSelection?.kind !== 'org') return undefined
  return orgRepoSelection.organization.login
}
